/**
 * Product Component
 * Handles product-specific functionality including final sale label
 */

class ComponentProduct {
  constructor(container) {
    this.container = container;
    this.finalSaleLabel = container.querySelector('[data-final-sale-label]');
    
    if (this.finalSaleLabel) {
      this.init();
    }
  }

  init() {
    // Watch for price changes
    this.observePriceChanges();
    // Check initial state
    this.updateLabel();
  }

  observePriceChanges() {
    const priceWrapper = this.container.querySelector('[data-price-wrapper]');
    if (!priceWrapper) return;

    const observer = new MutationObserver(() => {
      this.updateLabel();
    });

    observer.observe(priceWrapper, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  updateLabel() {
    if (!this.finalSaleLabel) return;
    
    const comparePriceEl = this.container.querySelector('[data-compare-price]');
    const salePriceEl = this.container.querySelector('[data-product-price]');
    
    if (!comparePriceEl || !salePriceEl) {
      this.hideLabel();
      return;
    }

    

    // Get variant data from product JSON
    const variant = this.getCurrentVariant();
    if (!variant || !variant.compare_at_price || !variant.price) {
      this.hideLabel();
      return;
    }

    const comparePrice = variant.compare_at_price;
    const salePrice = variant.price;


    if (comparePrice <= salePrice || comparePrice == salePrice) {
      this.hideLabel();
      return;
    }

    const discountInt = Math.round(((comparePrice - salePrice) / comparePrice) * 100);

    if (discountInt >= 25) {
      this.showLabel();
    }
    else if (comparePrice == salePrice){
      this.hideLabel();
    } else {
      this.hideLabel();
    }
  }

  getCurrentVariant() {
    const productJson = document.querySelector('[data-product-json]');
    if (!productJson) return null;

    try {
      const product = JSON.parse(productJson.textContent);
      const variantId = this.getSelectedVariantId();
      
      // Use selected variant if available, otherwise first available variant, otherwise first variant
      if (variantId) {
        const variant = product.variants.find(v => v.id === variantId);
        if (variant) return variant;
      }
      
      return product.variants.find(v => v.available) || product.variants[0];
    } catch (e) {
      return null;
    }
  }

  getSelectedVariantId() {
    const variantInput = this.container.querySelector('input[name="id"]');
    if (variantInput) {
      return parseInt(variantInput.value, 10);
    }
    
    const productForm = this.container.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const idInput = productForm.querySelector('input[name="id"]');
      if (idInput) {
        return parseInt(idInput.value, 10);
      }
    }
    
    return null;
  }

 showLabel() {
  document.querySelectorAll('[data-final-sale-label]').forEach(el => {
    el.classList.remove('hidden');
  });
}

hideLabel() {
  document.querySelectorAll('[data-final-sale-label]').forEach(el => {
    el.classList.add('hidden');
  });
}

}

// Initialize on product pages
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initComponentProduct);
} else {
  initComponentProduct();
}

function initComponentProduct() {
  const productSections = document.querySelectorAll('[data-section-type="product"]');
  
  productSections.forEach(section => {
    if (!section.componentProduct) {
      section.componentProduct = new ComponentProduct(section);
    }
  });
}

if (typeof window !== 'undefined') {
  window.ComponentProduct = ComponentProduct;
}
